<template>
  <b-card
    no-body
    :header="header"
    tag="article"
    class="mb-2"
  >
    <b-card-text class="p-3 m-0">
      <b-form-file
        drop-placeholder="將檔案拖曳至此"
        browse-text="瀏覽"
        placeholder="尚未選擇檔案"
        accept="image/jpeg, image/png, image/gif"
        :file-name-formatter="formatFilename"
        multiple
        @input="convertImage"
      />
    </b-card-text>

    <div v-if="files.length === 0">
      <b-card-img
        :src="waitingImage"
        alt="Image"
        class="rounded-0"
      />
    </div>
    <b-card-img
      v-for="(file, idx) in files"
      :key="idx"
      :src="file"
      alt="Image"
      bottom
    />
  </b-card>
</template>

<script>
  import mixin from '../lib/mixin.js';
  import waitingImage from '../assets/waiting-image.png';

  export default {
    name: 'BaseImageInput',
    mixins: [mixin],
    props: {
      header: {
        type: String,
        default: '',
      },
      maxImages: {
        type: Number,
        default: 3,
      },
    },
    data() {
      return {
        waitingImage,
        files: [],
      };
    },
    methods: {
      async convertImage(files) {
        this.files.length = 0;
        for (const file of files) {
          this.files.push(await this.imageToBase64(file));
        }
        this.files.splice(0, this.files.length - this.maxImages);
        const returnFiles = files.slice(0 - this.maxImages);
        this.$emit('loaded', returnFiles);
      },
      formatFilename(files) {
        if (files.length === 1) {
          return files[0].name;
        }
        const length = this.files.length > this.maxImages ? this.maxImages : this.files.length;
        return `已選擇 ${length} 張圖片`;
      },
    },
  };
</script>
